import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatCurrency, formatDate } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Skeleton } from "@/components/ui/skeleton";

export default function PartnerPayouts() {
  const [data, setData] = useState({ items: [], total_owed: 0, total_paid: 0 });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try { const res = await api.get("/portal/revenue"); setData(res.data); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div>
      <h2 className="font-display text-2xl font-bold text-[#252221] mb-1">Payouts</h2>
      <p className="text-sm text-muted-foreground mb-5">Your revenue share across MovingMyMama opportunities.</p>
      <div className="grid grid-cols-2 gap-4 mb-5">
        <Card className="p-5 border-[#E6EDF2]" style={{ boxShadow: "var(--mmm-shadow-sm)" }}>
          <div className="text-3xl font-bold font-display text-[#B7791F] tabular-nums">{formatCurrency(data.total_owed)}</div>
          <div className="text-sm text-muted-foreground">Owed to You</div>
        </Card>
        <Card className="p-5 border-[#E6EDF2]" style={{ boxShadow: "var(--mmm-shadow-sm)" }}>
          <div className="text-3xl font-bold font-display text-[#2F7D5A] tabular-nums">{formatCurrency(data.total_paid)}</div>
          <div className="text-sm text-muted-foreground">Paid to Date</div>
        </Card>
      </div>
      <Card className="border-[#E6EDF2] overflow-hidden" style={{ boxShadow: "var(--mmm-shadow-sm)" }}>
        {loading ? <div className="p-4 space-y-3">{[...Array(3)].map((_, i) => <Skeleton key={i} className="h-10" />)}</div> :
          data.items.length === 0 ? <div className="p-10 text-center text-muted-foreground">No payouts recorded yet.</div> : (
          <div className="overflow-x-auto mmm-scroll">
            <Table data-testid="partner-payouts-table">
              <TableHeader><TableRow className="hover:bg-transparent">
                <TableHead className="text-xs font-semibold text-[#1C4358]/80">Opportunity</TableHead>
                <TableHead className="text-xs font-semibold text-[#1C4358]/80">Share</TableHead>
                <TableHead className="text-xs font-semibold text-[#1C4358]/80">Amount</TableHead>
                <TableHead className="text-xs font-semibold text-[#1C4358]/80">Status</TableHead>
              </TableRow></TableHeader>
              <TableBody>
                {data.items.map((r, i) => (
                  <TableRow key={i} className="hover:bg-[rgba(155,185,206,0.10)]">
                    <TableCell className="py-3 font-medium text-[#252221]">{r.opportunity}</TableCell>
                    <TableCell className="text-sm">{r.pct}%</TableCell>
                    <TableCell className="text-sm tabular-nums">{formatCurrency(r.amount)}</TableCell>
                    <TableCell>
                      <span className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold border"
                        style={r.paid ? { backgroundColor: "rgba(47,125,90,0.12)", color: "#256B4B", borderColor: "rgba(47,125,90,0.28)" } : { backgroundColor: "rgba(183,121,31,0.14)", color: "#9A6516", borderColor: "rgba(183,121,31,0.30)" }}>
                        {r.paid ? "Paid" : "Owed"}
                      </span>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </Card>
    </div>
  );
}
